// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/infographic-page/infographic-page.component.scss
// module id = 384
// module chunks = 0